import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { RiffPcmEncoder } from "../common/Exports";
export var PcmRecorder = /*#__PURE__*/function () {
  function PcmRecorder(stopInputOnRelease) {
    var _this = this;

    _classCallCheck(this, PcmRecorder);

    this.record = function (context, mediaStream, outputStream) {
      var desiredSampleRate = 16000;
      var waveStreamEncoder = new RiffPcmEncoder(context.sampleRate, desiredSampleRate);
      var needHeader = true;
      var micInput = context.createMediaStreamSource(mediaStream);

      if (!_this.privSpeechProcessorScript) {
        var workletScript = "class SP extends AudioWorkletProcessor {\n                constructor(options) {\n                  super(options);\n                }\n                process(inputs, outputs) {\n                  const input = inputs[0];\n                  const output = [];\n                  for (let channel = 0; channel < input.length; channel += 1) {\n                    output[channel] = input[channel];\n                  }\n                  this.port.postMessage(output[0]);\n                  return true;\n                }\n              }\n              registerProcessor('speech-processor', SP);"; // tslint:disable-line:max-line-length

        var blob = new Blob([workletScript], {
          type: "application/javascript; charset=utf-8"
        });
        _this.privSpeechProcessorScript = URL.createObjectURL(blob);
      }

      var attachScriptProcessor = function attachScriptProcessor() {
        var scriptNode = function () {
          var bufferSize = 0;

          try {
            return context.createScriptProcessor(bufferSize, 1, 1);
          } catch (error) {
            // Webkit (<= version 31) requires a valid bufferSize.
            bufferSize = 2048;
            var audioSampleRate = context.sampleRate;

            while (bufferSize < 16384 && audioSampleRate >= 2 * desiredSampleRate) {
              bufferSize <<= 1;
              audioSampleRate >>= 1;
            }

            return context.createScriptProcessor(bufferSize, 1, 1);
          }
        }();

        scriptNode.onaudioprocess = function (event) {
          var inputFrame = event.inputBuffer.getChannelData(0);

          if (outputStream && !outputStream.isClosed) {
            var waveFrame = waveStreamEncoder.encode(inputFrame);

            if (!!waveFrame) {
              outputStream.writeStreamChunk({
                buffer: waveFrame,
                isEnd: false,
                timeReceived: Date.now()
              });
              needHeader = false;
            }
          }
        };

        micInput.connect(scriptNode);
        scriptNode.connect(context.destination);
        _this.privMediaResources = {
          scriptProcessorNode: scriptNode,
          source: micInput,
          stream: mediaStream
        };
      }; // https://webaudio.github.io/web-audio-api/#audioworklet
      // Using AudioWorklet to improve audio quality and avoid audio glitches due to blocking the UI thread


      if (!!_this.privSpeechProcessorScript && !!context.audioWorklet) {
        context.audioWorklet.addModule(_this.privSpeechProcessorScript).then(function () {
          var workletNode = new AudioWorkletNode(context, "speech-processor");

          workletNode.port.onmessage = function (ev) {
            var inputFrame = ev.data;

            if (outputStream && !outputStream.isClosed) {
              var waveFrame = waveStreamEncoder.encode(inputFrame);

              if (!!waveFrame) {
                outputStream.writeStreamChunk({
                  buffer: waveFrame,
                  isEnd: false,
                  timeReceived: Date.now()
                });
                needHeader = false;
              }
            }
          };

          micInput.connect(workletNode);
          workletNode.connect(context.destination);
          _this.privMediaResources = {
            scriptProcessorNode: workletNode,
            source: micInput,
            stream: mediaStream
          };
        }).catch(function () {
          attachScriptProcessor();
        });
      } else {
        try {
          attachScriptProcessor();
        } catch (err) {
          throw new Error("Unable to start audio worklet node for PCMRecorder: ".concat(err));
        }
      }
    };

    this.releaseMediaResources = function (context) {
      if (_this.privMediaResources) {
        if (_this.privMediaResources.scriptProcessorNode) {
          _this.privMediaResources.scriptProcessorNode.disconnect(context.destination);

          _this.privMediaResources.scriptProcessorNode = null;
        }

        if (_this.privMediaResources.source) {
          _this.privMediaResources.source.disconnect();

          if (_this.privStopInputOnRelease) {
            _this.privMediaResources.stream.getTracks().forEach(function (track) {
              return track.stop();
            });
          }

          _this.privMediaResources.source = null;
        }
      }
    };

    this.privStopInputOnRelease = stopInputOnRelease;
  }

  _createClass(PcmRecorder, [{
    key: "setWorkletUrl",
    value: function setWorkletUrl(url) {
      this.privSpeechProcessorScript = url;
    }
  }]);

  return PcmRecorder;
}();